/**
 * The list of view breakpoints. The list should be always in ascending order.
 * @type {{small: number, owllarge: number, large: number, xlarge: number, medium: number}}
 */
const ViewBreakpoints = {
  small: 320,
  medium: 640,
  large: 1024,
  xlarge: 1200,
  xxlarge: 1440,
};

export {ViewBreakpoints};
